import React from "react";

import { Typography, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import OrderDetails from "../orderDetails/OrderDetails";

import { DataGrid } from "@material-ui/data-grid";
import NoRowsMessage from "../../../components/NoRowsMessage";
import CustomLoading from "../../../components/CustomLoading";
import { utils } from "../../../validation/ValidationFunctions";

const TransactionsTable = ({ modal_loading, data, historyReducer }) => {
  // let [orders ]
  let d = data.slice(
    historyReducer.page * historyReducer.perPage,
    historyReducer.page * historyReducer.perPage + historyReducer.perPage
  );

  const CustomFooter = () => {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ padding: "16px 8px" }}
      >
        <Grid item>
          <Typography variant="body1" style={{ marginRight: 30 }}>
            مانده{" "}
          </Typography>
        </Grid>
        <Grid container item xs={8} justifyContent="flex-end">
          <Typography
            variant="body1"
            style={{ width: 150, textAlign: "center", color: "rgb(194,30,86)" }}
          >
            {d
              .reduce((total, item, index) => {
                if (item.bed) {
                  return total + item.bed;
                }

                return total + 0;
              }, 0)
              .toLocaleString()}
          </Typography>
          <Typography
            variant="body1"
            style={{ width: 150, textAlign: "center", color: "rgb(0,179,65)" }}
          >
            {d
              .reduce((total, item, index) => {
                if (item.bes) return total + item.bes;

                return total + 0;
              }, 0)
              .toLocaleString()}
          </Typography>
          {/* <Typography
            variant="body1"
            style={{ width: 150, textAlign: "center" }}
          >
            {d
              .reduce((total, item, index) => {
                return total + item.stock;
              }, 0)
              .toLocaleString()}
          </Typography> */}
        </Grid>
      </Grid>
    );
  };
  return (
    <DataGrid
      columns={customer_header_list}
      rows={data}
      loading={modal_loading}
      sortingOrder={["desc", "asc"]}
      disableSelectionOnClick
      page={historyReducer?.page}
      disableColumnFilter
      disableColumnMenu
      pageSize={historyReducer.perPage}
      components={{
        NoRowsOverlay: NoRowsMessage,
        LoadingOverlay: CustomLoading,
        Footer: CustomFooter,
      }}
    />
  );
};

const mapToStateProps = (props) => {
  const { OrderReducer, historyReducer } = props;
  const { modal_loading } = OrderReducer;

  return { modal_loading, historyReducer };
};

export default connect(mapToStateProps)(TransactionsTable);

const customer_header_list = [
  {
    field: "numbesssr",
    headerName: "شماره سفارش",
    width: 180,
    sortable: false,
    headerAlign: "center",
    align: "center",
    renderCell: (value) => (
      <OrderDetails
        rowValue={value.row?.order?.order_number}
        orderId={value.row?.order?.id}
        position="number"
      />
    ),
  },
  {
    field: "cDate",
    headerName: "تاریخ",
    width: 100,

    headerAlign: "center",
    align: "center",

    renderCell: (value) => (
      <Typography variant="body2">
        {utils.today(new Date(value.value))}
      </Typography>
    ),
  },
  {
    field: "cDateسس",
    headerName: "ساعت",
    width: 100,
    sortable: false,
    headerAlign: "center",
    align: "center",

    renderCell: (value) => (
      <Typography variant="body2">
        {utils.get_time(new Date(value.row.cDate))}
      </Typography>
    ),
  },
  {
    field: "descr",
    headerName: "توضیحات",
    flex: 0.4,
    headerAlign: "left",
    align: "left",

    renderCell: (value) => (
      <Typography variant="body2">{value?.value}</Typography>
    ),
  },
  {
    field: "bed",
    headerName: "بدهکار",
    headerAlign: "center",
    align: "center",
    width: 150,
    renderCell: (value) => (
      <Typography variant="body2">{value?.value?.toLocaleString()}</Typography>
    ),
  },
  {
    field: "bes",
    headerName: "بستانکار",
    headerAlign: "center",
    align: "center",
    width: 150,
    renderCell: (value) => (
      <Typography variant="body2">{value?.value?.toLocaleString()}</Typography>
    ),
  },
  // {
  //   field: "stock",
  //   headerName: "بالانس",
  //   headerAlign: "center",
  //   align: "center",
  //   width: 150,
  //   renderCell: (value) => (
  //     <Typography variant="body2">{value?.value?.toLocaleString()}</Typography>
  //   ),
  // },
];
